<template>
  <div />
</template>

<script>
import Vue from 'vue'
import DeWithdrawalForm from '~assets/files/brands/austrian/withdrawal/de.pdf'
import EnWithdrawalForm from '~assets/files/brands/austrian/withdrawal/en.pdf'

export default Vue.extend({
  computed: {
    currentLocale() {
      return this.$i18n.locale
    },
    pdfUrl() {
      return this.currentLocale === 'de' ? DeWithdrawalForm : EnWithdrawalForm
    },
  },
  mounted() {
    this.redirectToPdf()
  },
  methods: {
    redirectToPdf() {
      if (this.pdfUrl) {
        window.location.href = this.pdfUrl
      }
    },
  },
})
</script>
